/**
 * aiConsentLaunch — PROD-1225. The app's single launch check against GET /ai-consent/status
 * (see utils/aiConsentSignal.js for the rules). Shared by the protected-route gate in App.jsx,
 * which reads it, and the re-consent screen, which marks it consented after a successful record,
 * so the cached answer can never send the patient back to the screen they just finished.
 */
import { aiConsentAPI } from './api'
import { createLaunchCheck } from '../utils/aiConsentSignal'

export const aiConsentLaunch = createLaunchCheck(() => aiConsentAPI.status())
